import gql from 'graphql-tag';

export const GET_NOTIFICATIONS_QUERY = gql`
query notifications {
  notifications {
    body
    id
    insertedAt
    uri
    viewedAt
    triggeredByUser {
      id
      username
      avatar {
        thumb
      }
    }
  }
}
`;

export const NOTIFICATION_SETTINGS_FRAGMENT = gql`
fragment notificationSettingsFragment on NotificationSetting{
  description
  displayOrder
  emailEnabled
  hasEmail
  hasOnSite
  name
  onSiteEnabled
  typeId
}
`;

export const GET_NOTIFICATION_SETTINGS_QUERY = gql`
${NOTIFICATION_SETTINGS_FRAGMENT}
query notificationSettings{
  notificationSettings {
    ...notificationSettingsFragment
    notificationSettings{
      ...notificationSettingsFragment
    }
  }
}
`;
